/*
 * 数据相关 helper
 *
 * @Author: xiaoJQ
 * @Date: 2024-06-07 17:32:31
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { v4 } from 'uuid';
import keyJson from 'components/util/key.json';
export function generateTable(data, typeSeq) {
    var tableKeys = Object.keys(data);
    // const tableShapeData = []
    var tableShapeData = [];
    var tableData = {};
    tableKeys.forEach(function (key) {
        var tableId = v4();
        tableData[key] = {
            tableId: tableId,
            tableData: data[key].map(function (item, index) {
                var _a = generateTableLineData(item, index, key, tableId), tableLineData = _a.tableLineData, unitData = _a.unitData;
                tableShapeData = tableShapeData.concat(unitData.map(function (unit) {
                    return __assign(__assign({}, unit), { tableFlag: true });
                }));
                return {
                    tableLineIndex: index,
                    tableLineData: tableLineData,
                };
            }),
        };
    });
    return {
        tableData: tableData,
        tableShapeData: tableShapeData,
    };
}
export function generateTableLineData(data, tableLineIndex, tableKey, tableId) {
    var tableLineKeys = Object.keys(data);
    var tableLineData = {};
    var unitData = [];
    tableLineKeys.forEach(function (key) {
        var unit = [];
        if (data[key].indexNew.length === 0) {
            var extractId = v4();
            var shapeId = v4();
            unit = [
                {
                    shapeId: shapeId,
                    lineKey: key,
                    extractId: extractId,
                    tableId: tableId,
                    key: key,
                    tableKey: tableKey,
                    confidence: data[key].confidence,
                    pageNum: undefined,
                    wordsLocation: undefined,
                    infoText: data[key].text,
                    type: 'tableJson',
                    words: undefined,
                },
            ];
        }
        if (data[key].indexNew.length > 0) {
            var extractId_1 = v4();
            unit = data[key].indexNew.map(function (item) {
                var shapeId = v4();
                return {
                    shapeId: shapeId,
                    lineKey: key,
                    extractId: extractId_1,
                    tableId: tableId,
                    key: key,
                    tableKey: tableKey,
                    confidence: data[key].confidence,
                    pageNum: item.pageNum,
                    wordsLocation: item.wordsLocation,
                    infoText: data[key].text,
                    type: 'tableJson',
                    words: item.words,
                };
            });
        }
        unitData = unitData.concat(unit);
        tableLineData[key] = {
            confidence: data[key].confidence,
            data: unit,
            drawData: [],
            inputType: '1',
            key: 'key',
            tableId: tableId,
            tableKey: tableKey,
            tableLineIndex: tableLineIndex,
            lineKey: key,
            select: unit.length > 0 ? unit[0].extractId : null,
            selectType: unit.length > 0 ? unit[0].type : null,
            value: unit.length > 0 ? unit[0].infoText : '',
        };
    });
    return {
        unitData: unitData,
        tableLineData: tableLineData,
    };
}
export function generateImportData(extractData) {
    var _a;
    var taskId = extractData.taskId;
    var updateData = JSON.stringify(extractData);
    var importData = extractData.data.listJson.map(function (item) {
        var _a;
        return _a = {},
            _a[item.key] = {
                name: keyJson[item.key],
                value: item.value,
            },
            _a;
    });
    var tableListJson = extractData.data.tableListJson;
    var keys = Object.keys(tableListJson);
    var importTableData = {};
    keys.forEach(function (key) {
        importTableData[key] = tableListJson[key].tableData.map(function (line) {
            var headerKeys = Object.keys(line.tableLineData);
            var newLineData = {};
            headerKeys.forEach(function (key) {
                newLineData[key] = line.tableLineData[key].value;
            });
            return newLineData;
        });
    });
    var llmTableListJson = (_a = extractData.data) === null || _a === void 0 ? void 0 : _a.llmTableListJson;
    if (llmTableListJson) {
        var llmKeys = Object.keys(llmTableListJson);
        llmKeys.forEach(function (key) {
            importTableData[key] = llmTableListJson[key].tableData.map(function (line) {
                var headerKeys = Object.keys(line.tableLineData);
                var newLineData = {};
                headerKeys.forEach(function (key) {
                    newLineData[key] = line.tableLineData[key].value;
                });
                return newLineData;
            });
        });
    }
    return {
        taskId: taskId,
        updateData: updateData,
        importData: importData,
        importTableData: importTableData,
    };
}
